import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const idDocumentTypesApi = createApi({
  reducerPath: 'idDocumentTypesApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URl}/id_document_types`,
  }),
  endpoints: builder => ({
    getIdDocumentTypes: builder.query({
      query: () => '/',
      transformResponse: ({ result }) => result,
    }),
  }),
});

export const { useGetIdDocumentTypesQuery } = idDocumentTypesApi;
